import favouriteService from "@/services/favouriteService";

const state = {
    currentPage: undefined,
    nextPage: null,
    count: null,
    favourites: [],
}

const actions = {
    getFavourites({commit}, params) {
        return new Promise((resolve, reject) => {
            favouriteService.fetchFavourites(params)
                .then((response) => {
                    commit('addFavourites', response.results);
                    commit('setCount', response.count);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    getFavouritesList({commit}, payload) {
        return new Promise((resolve, reject) => {
            favouriteService.fetchFavoritesList(payload)
                .then((response) => {
                    commit('addFavourites', response)
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    addFavourite({commit}, payload) {
        return new Promise((resolve, reject) => {
            favouriteService.postFavourite(payload)
                .then((response) => {
                    commit('addFavourite', payload.product_id);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    deleteFavourite({commit}, productId) {
        return new Promise((resolve, reject) => {
            favouriteService.deleteFavourite(productId)
                .then((response) => {
                    commit('removeFavourite', productId);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

const mutations = {
    addFavourites(state, response) {
        const productIds = response.map(favourite => favourite.product_id).filter(id => !state.favourites.includes(id));
        state.favourites = state.favourites.concat(productIds);
    },
    addFavourite(state, productId) {
        state.favourites.push(productId);
        state.count += 1;
    },
    removeFavourite(state, productId) {
        state.favourites = state.favourites.filter(id => id !== productId);
        state.count -= 1;
    },
    setCount(state, count) {
        state.count = count;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}